import { render, staticRenderFns } from "./SpaceHouse.vue?vue&type=template&id=89e5d712&"
import script from "./SpaceHouse.vue?vue&type=script&lang=js&"
export * from "./SpaceHouse.vue?vue&type=script&lang=js&"
import style0 from "./SpaceHouse.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports